// extracted by mini-css-extract-plugin
export default {"button":"IntegrationSyncNowButton-module__button___SAbQj"};